import { FileResponseItem } from './file-response-item';

export interface FileResponse {
  files: FileResponseItem[];
}

export interface DownloadedDocumentResponse {
  documentName: string;
  content: string;
  guid?: string;
}
